module.exports = __webpack_public_path__ + "static/1-05e3c547cea703b964af31314f89b843.png";